import Vue from 'vue'

import header from './header.vue'
Vue.component('headercomponent', header)




// WEBPACK FOOTER //
// ./src/components/index.js